module.exports = __webpack_public_path__ + "static/img/securefixation.5353a979.svg";